import React, { lazy, Suspense, useCallback, useState } from 'react';
import Seo from './Seo';
import LandingSections, {
  HOME_TITLE,
  HOME_DESCRIPTION,
  HOME_JSON_LD,
} from './LandingSections';

// The tool ships Babylon.js etc., so it stays code-split; the (light) landing
// sections below render immediately from the main bundle while it loads.
const CreateCanvas = lazy(() => import('./CreateCanvas'));

// Mirrors the design step's container (min-h-screen, sidebar offset) so the
// page doesn't shift when the CreateCanvas chunk arrives.
const ToolSkeleton = () => (
  <div className="flex min-h-screen items-center justify-center bg-gray-800 md:ml-16">
    <div className="h-10 w-10 animate-spin rounded-full border-4 border-white/20 border-t-rose-500" />
  </div>
);

/**
 * '/' — visitors land directly in the create tool (the design step is the
 * hero), with the marketing/SEO sections below it. Once the user advances
 * past the design step the sections unmount: the later steps are immersive
 * full-viewport screens and nothing should scroll beneath them.
 */
export default function CreateHome() {
  const [inDesignStep, setInDesignStep] = useState(true);

  const handleFlowStepChange = useCallback((step) => {
    const isDesign = step === 'design';
    setInDesignStep(isDesign);
    // Entering the 3D flow while scrolled into the landing sections would
    // leave the viewport mid-page; snap back to the tool.
    if (!isDesign) window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Owns the page metadata — always mounted, unlike the sections below. */}
      <Seo
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        path="/"
        jsonLd={HOME_JSON_LD}
      />

      <Suspense fallback={<ToolSkeleton />}>
        <CreateCanvas embedded onFlowStepChange={handleFlowStepChange} />
      </Suspense>

      {inDesignStep && <LandingSections />}
    </>
  );
}
